const SQLITE_TYPES = new Set([
  "application/vnd.sqlite3",
  "application/x-sqlite3",
]);

const EXT_TO_MEDIA_TYPE: Record<string, string> = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  webp: "image/webp",
  txt: "text/plain",
  log: "text/plain",
  md: "text/markdown",
  markdown: "text/markdown",
  csv: "text/csv",
  html: "text/html",
  htm: "text/html",
  json: "application/json",
  jsonl: "application/jsonl",
  ndjson: "application/jsonl",
  pdf: "application/pdf",
  db: "application/vnd.sqlite3",
  sqlite: "application/vnd.sqlite3",
  sqlite3: "application/vnd.sqlite3",
  db3: "application/vnd.sqlite3",
  toml: "application/toml",
  xml: "application/xml",
  yaml: "application/yaml",
  yml: "application/yaml",
  zip: "application/zip",
  tar: "application/x-tar",
  gz: "application/gzip",
  tgz: "application/gzip",
};

export function isSqliteMediaType(mediaType: string): boolean {
  return SQLITE_TYPES.has(mediaType);
}

export function mediaTypeFromFileName(name: string): string {
  const dot = name.lastIndexOf(".");
  if (dot < 0 || dot === name.length - 1) return "application/octet-stream";
  const ext = name.slice(dot + 1).toLowerCase();
  return EXT_TO_MEDIA_TYPE[ext] ?? "application/octet-stream";
}
